<template lang="pug">
.images.flex(:class="{ 'is-dragging': dragging }" ref="container")
    //- el-form-item(
    //-     v-if="maxWidth !== undefined"
    //-     :label="$t(config.name)"
    //-     :class="{ 'flex': images.length }"
    //- )
    .replace-action(v-if="showLibraryAction && libraryActionMode === 'replace'")
        el-button.image-library-button.image-library-button--replace(
            plain
            size="small"
            icon="el-icon-picture-outline"
            @click="openLibrary(libraryActionMode)"
        ) {{ openLibraryLabel }}
    draggable.list(
        v-if="images.length"
        v-model="images"
        :group="`${parent.id}:images`"
        draggable="li.draggable"
        @start="dragging = true"
        @end="dragging = false"
    )
        transition-group(name="fade" tag="ul" class="no-style-list")
            li.image.draggable(
                v-for="image in images"
                :key="`${image.id}:${renderNonce}`"
            )
                a(
                    href="#"
                    @click.prevent="! image.deleted && openImageModal(image.id)"
                    :class="{ deleted: image.deleted }"
                )
                    //- include image-tile.pug
                    .image-input
                        image-field(
                            v-if="maxWidth"
                            :config="config.image"
                            :image="image"
                            :height="height"
                            :max-width="maxWidth"
                            :aspect-ratio="aspectRatio"
                        )
                    .edit-popover
                        i.el-icon-fa-pencil.fas

                    el-button.restore-image(
                        v-if="image.deleted"
                        circle type="info" size="mini"
                        icon="el-icon-fa-trash-restore fas"
                        @click.prevent.stop="restoreImage(image.id)"
                    )
                    el-button.delete-image(
                        v-else-if="isDeletable"
                        circle type="danger" size="mini"
                        icon="el-icon-fa-trash-alt far"
                        @click.prevent.stop="deleteImage(image.id)"
                    )
    .image-sort-hint(v-if="images.length > 1")
        i.el-icon-rank
        span {{ $t('Drag and drop to reorder images') }}

    .dropzone-block
        .image-actions(v-if="showLibraryAction && libraryActionMode !== 'replace'")
            el-button.image-library-button(
                type="primary"
                size="medium"
                icon="el-icon-picture-outline"
                @click="openLibrary(libraryActionMode)"
            ) {{ openLibraryLabel }}
            .image-actions__hint {{ openLibraryHint }}
        el-upload.plus-box.has-info(
            v-if="! max || images.length < max"
            ref="upload"
            drag multiple :action="uploadEndpoint"
            accept="image/jpg, image/jpeg, image/png"
            :before-upload="validateUpload"
            :on-change="uploadChanged"
            :on-success="uploadSucceeded"
            :on-error="uploadFailed"
            :headers="uploadHeaders"
            :data="uploadData"
            :limit="! max ? null : max"
        )
            i.el-icon-plus
            // i.el-icon-upload.el-icon-fa-cloud-upload-alt.fas
            .el-upload__text(v-html=" ! max || max > 1 ? $t('upload.drop.plural') : $t('upload.drop.singular')")
            .el-upload__tip(slot="tip") {{ $t('upload.validation', { filetypes: 'jpg/png', size: `${maxSize}mb`}) }}

    el-dialog.image-dialog(
        :title="$t('Image settings')"
        :visible.sync="imageModal.visibility"
        :before-close="confirmDiscard(() => imageModal.cropMoved || selectedAspectRatioKey !== 'original')"
        :close-on-click-modal="false"
        :width="modalWidth"
        :append-to-body="true"
        top="4vh"
        @opened="imageModal.loading = false"
        @closed="resetImageModal"
    )
        .image-dialog-actions(v-if="! imageModal.loading")
            el-button(
                v-if="imageModal.form.image"
                plain
                size="mini"
                icon="el-icon-picture-outline"
                @click="openReplaceLibrary"
            ) {{ $t('Replace image') }}
            .aspect-ratio-group(v-if="aspectRatio === null")
                el-dropdown(@command="selectedAspectRatioKey = $event" trigger="click")
                    el-button(size="mini" plain icon="el-icon-fa-crop-alt fas")
                        | {{ $t('Aspect ratio') }} ({{ selectedAspectRatioDisplayLabel }})
                        i.el-icon-arrow-down.el-icon--right
                    el-dropdown-menu(slot="dropdown")
                        el-dropdown-item(
                            v-for="option in aspectRatioOptions"
                            :key="option.key"
                            :command="option.key"
                            :class="{ 'is-selected': selectedAspectRatioKey === option.key }"
                        ) {{ option.label }}
                el-input(
                    v-if="selectedAspectRatioKey === 'custom'"
                    v-model="customAspectRatioInput"
                    size="mini"
                    :placeholder="$t('e.g. 16:9')"
                    style="width: 90px"
                )
        .modal-body(v-if="! imageModal.loading" :class="imageModal.form.orientation" v-loading="! imageModal.form.preview")
            .cropper-box
                .container(:style="{ width: (imageModal.form.dimensions.width + 10) + 'px' }")
                    // :img-style="{ 'width': imageModal.form.image.width, 'height': imageModal.form.image.height }"
                    vue-cropper(
                        :key="cropperKey"
                        ref="cropper"
                        drag-mode="crop"
                        :src="imageModal.form.src"
                        :ready="handleCropperReady"
                        :cropend="markCropMoved"
                        :rotatable="false"
                        :background="false"
                        :restore="false"
                        :check-orientation="false"
                        :img-style="{ height: imageModal.form.dimensions.height + 'px' }"
                        :view-mode="2"
                        :zoomable="false"
                        :data="imageModal.form.crop"
                        :auto-crop-area="1"
                        :aspect-ratio="effectiveAspectRatio"
                        :crop="debouncedUpdateCrop"
                    )
            .content-sidebar(v-if="imageModal.form.preview")
                .alt-text-feature(:class="{ 'alt-text-feature--plain': !altAutoEnabled }")
                    .alt-text-feature__header
                        .alt-text-feature__label
                            i.el-icon-fa-magic.fas
                            span {{ $t('Alternate text for IMG tags') }}
                        .alt-text-feature__meta
                            el-tooltip(
                                v-if="mistralEnabled && altAutoEnabled"
                                :disabled="!altLastTokens"
                                :content="altLastTokens ? `Input: ${altLastTokens.input} · Output: ${altLastTokens.output} Tokens` : ''"
                                placement="top"
                                effect="dark"
                                :append-to-body="true"
                            )
                                el-tag.alt-text-feature__badge(size="mini" effect="dark") {{ $t('AI') }}
                            el-popover(placement="right" width="250" trigger="hover")
                                span {{ $t('alt_hint') }}
                                el-button.alt-text-feature__help(slot="reference" circle size="mini") ?
                    el-input.alt-text-feature__input(
                        v-model="imageModal.form.image.alt"
                        :placeholder="imageModal.form.image.description || $t('alt_placeholder')"
                        maxlength="255"
                        show-word-limit
                    )
                    .alt-text-feature__footer(v-if="mistralEnabled && altAutoEnabled")
                        el-tooltip(
                            v-if="altGenerateCount >= altMaxGenerations"
                            :content="$t('alt_limit_hint')"
                            placement="top"
                            effect="dark"
                        )
                            el-button.alt-text-feature__btn(
                                size="small"
                                disabled
                                icon="el-icon-fa-magic fas"
                            ) {{ imageModal.form.image && imageModal.form.image.alt ? $t('Regenerate alt text') : $t('Generate alt text') }}
                        el-button.alt-text-feature__btn(
                            v-else
                            size="small"
                            :loading="altGenerating"
                            icon="el-icon-fa-magic fas"
                            @click="regenerateAlt"
                        ) {{ imageModal.form.image && imageModal.form.image.alt ? $t('Regenerate alt text') : $t('Generate alt text') }}
                        p.alt-text-feature__hint(v-if="altGenerateCount > 0 && altGenerateCount < altMaxGenerations") {{ $tc('alt_remaining_hint', altMaxGenerations - altGenerateCount) }}
                        p.alt-text-feature__hint {{ $t('ai_alt_hint') }}
        template(slot="footer")
            el-button(
                size="mini"
                icon="el-icon-fa-times fas"
                @click="closeImageModal"
            ) {{ $t('Dismiss') }}
            el-button(
                size="mini"
                type="primary"
                icon="el-icon-fa-check fas"
                @click="acceptImageModal"
            ) {{ $t('Ok') }}

    image-library-dialog(
        :visible.sync="libraryModal.visibility"
        :multiple="libraryAllowsMultiple"
        :selection-limit="librarySelectionLimit"
        @select="selectImageFromLibrary"
    )
</template>

<i18n>
{
    "de": {
        "Could not find the content.": "Der Inhalt konnte nicht gefunden werden.",
        "Image settings": "Bild-Einstellungen",
        "Alternate text for IMG tags": "Bildbeschreibung (Alt-Text)",
        "alt_hint": "Der Alternativtext dient der Barrierefreiheit, indem er den Bildinhalt für Screenreader beschreibt und dem Nutzer eine textliche Entsprechung bietet, falls das Bild nicht geladen werden kann.",
        "No images found.": "Es konnten keine Bilder gefunden werden",
        "Open media library": "Mediathek öffnen",
        "Select multiple images": "Mehrere Bilder auswählen",
        "Replace image": "Bild austauschen",
        "Aspect ratio": "Bildseitenverhältnis",
        "Original aspect ratio": "Originales Verhältnis",
        "Custom": "Benutzerdefiniert",
        "e.g. 16:9": "z.B. 16:9",
        "Select image from media library": "Bild aus Mediathek auswählen",
        "Select images from media library": "Bilder aus Mediathek auswählen",
        "Select an existing image from the media library or upload a new one below.": "Ein vorhandenes Bild aus der Mediathek auswählen oder unten ein neues hochladen.",
        "Select existing images from the media library or upload new ones below.": "Vorhandene Bilder aus der Mediathek auswählen oder unten neue hochladen.",
        "Replace the current image with one from the media library.": "Das aktuelle Bild durch eines aus der Mediathek ersetzen.",
        "Drag and drop to reorder images": "Bilder per Drag and Drop sortieren",
        "Generate alt text": "Alt-Text generieren",
        "Regenerate alt text": "Alt-Text neu generieren",
        "Alt text could not be generated.": "Alt-Text konnte nicht generiert werden.",
        "AI": "KI",
        "ai_alt_hint": "KI-generiert (Mistral AI, Europa) · Bitte vor Veröffentlichung prüfen.",
        "alt_placeholder": "Kurze Bildbeschreibung für Screenreader...",
        "alt_limit_hint": "Limit erreicht · Bitte den Text manuell anpassen.",
        "alt_remaining_hint": "Noch 1 Generierung verfügbar | Noch {count} Generierungen verfügbar",
        "alt_generated_notify": "Alt-Text wurde automatisch generiert.",
        "alt_generated_batch": "Bilder wurden automatisch mit Alt-Text versehen.",
        "alt_limit_reached_notify": "Limit erreicht – Alt-Text bitte manuell prüfen."
    },
    "en": {
        "ai_alt_hint": "AI-generated (Mistral AI, Europe) · Please review before publishing.",
        "alt_placeholder": "Short image description for screen readers...",
        "alt_limit_hint": "Limit reached · Please adjust the text manually.",
        "alt_remaining_hint": "1 generation left | {count} generations left",
        "alt_generated_notify": "Alt text was generated automatically.",
        "alt_generated_batch": "images were given alt text automatically.",
        "alt_limit_reached_notify": "Limit reached – please review the alt text manually."
    }
}
</i18n>

<script>
import _ from 'lodash'
import axios from 'axios'

import draggable from 'vuedraggable'
import { useAuthStore, useSetupStore } from '@/stores'

import uniqid from 'uniqid';

import store from '@/store'
import AuthApi from '@/store/api/system/auth';

import {
    set,
    ensureFreshToken,
    addContentToSection,
    sortContents,
} from '@/helpers'

import VueCropper from 'vue-cropperjs'
import ImageField from './ImageContent/ImageField'
import InputField from './InputField'
import ImageLibraryDialog from './ImageLibraryDialog'
import discardGuard from '@/mixins/discardGuard'

export default {
    name: 'SectionImageField',
    mixins: [discardGuard],
    props: {
        parent: {
            type: Object,
            required: false
        },
        config: {
            type: Object,
            required: true
        },
        height: {
            type: Object,
            default: () => {
                return {
                    preview: 56,
                    edit: 72,
                }
            }
        },
    },
    data() {
        return {
            maxWidth: undefined,
            debouncedCalculateMaxWidth: null,
            resizeObserver: null,

            // visibleSettings: false,

            imageModal: {
                visibility: false,
                loading: false,
                // true once the user has dragged the crop box; typed alt text is bound to the
                // image itself and survives a close
                cropMoved: false,
                form: {
                    orientation: undefined,
                    dimensions: {},
                    crop: {},
                    image: undefined,
                    src: undefined,
                    preview: undefined,
                    i: 0,
                },
            },

            libraryModal: {
                visibility: false,
                mode: 'add',
            },

            renderNonce: 0,
            dragging: false,
            selectedAspectRatioKey: 'original',
            customAspectRatioInput: '',
            altGenerating: false,
            altGenerateCount: 0,
            altLastTokens: null,
            altBatchPending: 0,
            altBatchCompleted: 0,
        }
    },
    components: {
        ImageField,
        // InputField,
        ImageLibraryDialog,
        VueCropper,
        draggable
    },
    watch: {
        effectiveAspectRatio(newVal) {
            if (this._detectingAspectRatio) return
            const cropper = this.getCropperInstance()
            if (cropper) {
                cropper.setAspectRatio(newVal != null ? newVal : NaN)
            }
        },
        'images.length'() {
            this.$nextTick(() => {
                this.calculateMaxWidth()
            })
        },
        'libraryModal.visibility'(visible) {
            if (!visible) {
                this.$nextTick(() => {
                    this.calculateMaxWidth()
                })
            }
        },
    },
    computed: {
        uploadHeaders() {
            return {
                authorization: `Bearer ${useAuthStore().token}`,
                accept: 'application/json',
            }
        },
        isDeletable() {
            const images = this.parent.images.filter(el => ! el.deleted)
            return this.min === null || this.min < images.length
        },
        aspectRatio() {
            let result = null;

            let aspectRatio = _.get(this.config, 'aspectRatio', false);
            if (aspectRatio) {
                const w = _.get(aspectRatio, 'width')
                const h = _.get(aspectRatio, 'height')

                if (w && h) result = w / h
            }

            return result;
        },
        aspectRatioOptions() {
            return [
                { key: 'original', label: this.$t('Original aspect ratio') },
                { key: '1:1', label: '1:1' },
                { key: '4:3', label: '4:3' },
                { key: '3:2', label: '3:2' },
                { key: '16:9', label: '16:9' },
                { key: '2:3', label: '2:3' },
                { key: '3:4', label: '3:4' },
                { key: '9:16', label: '9:16' },
                { key: 'custom', label: this.$t('Custom') },
            ]
        },
        effectiveAspectRatio() {
            if (this.selectedAspectRatioKey === 'original') {
                return this.aspectRatio
            }
            if (this.selectedAspectRatioKey === 'custom') {
                if (!this.customAspectRatioInput) return this.aspectRatio
                const parts = this.customAspectRatioInput.split(':').map(s => parseFloat(s.trim()))
                if (parts.length === 2 && parts[0] > 0 && parts[1] > 0) return parts[0] / parts[1]
                const num = parseFloat(this.customAspectRatioInput)
                return (!isNaN(num) && num > 0) ? num : this.aspectRatio
            }
            const [w, h] = this.selectedAspectRatioKey.split(':').map(Number)
            return (w && h) ? w / h : this.aspectRatio
        },
        selectedAspectRatioDisplayLabel() {
            if (this.selectedAspectRatioKey === 'original') {
                const ratio = this.aspectRatio
                if (!ratio) return 'Original'
                const match = this.aspectRatioOptions.find(o => {
                    if (o.key === 'original' || o.key === 'custom') return false
                    const [w, h] = o.key.split(':').map(Number)
                    return w && h && Math.abs((w / h) - ratio) < 0.001
                })
                return match ? match.key : 'Original'
            }
            if (this.selectedAspectRatioKey === 'custom') {
                return this.customAspectRatioInput || this.$t('Custom')
            }
            return this.selectedAspectRatioKey
        },
        modalWidth() {
            let width = 540

            // image is content by itself
            if (this.imageModal.form.orientation === 'landscape') {
                width = 1200
            } else if (this.imageModal.form.dimensions && this.imageModal.form.dimensions.width) {
                // add 380 px for the alt input field
                width = this.imageModal.form.dimensions.width + 80 + 380 + 40
            }

            return `${width}px`
        },
        images: {
            get() {
                return _.get(this.parent, 'images', [])
                    .filter(el => el.type === this.config.key)
                    .sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0));
            },
            set(sorted) {
                let images = _.get(this.parent, 'images', [])
                    .filter(el => el.type === this.config.key)
                images.forEach(image => {
                    const i = sorted.findIndex(el => el.id === image.id)
                    image.position = i + 1
                });
                sortContents(images)
            }
        },
        min() {
            return _.get(this.config, 'min')
        },
        max() {
            return _.get(this.config, 'max')
        },
        librarySelectionLimit() {
            if (this.libraryModal.mode !== 'add') return 1
            if (! this.max) return null

            return Math.max(this.max - this.images.length, 0)
        },
        libraryAllowsMultiple() {
            return this.libraryModal.mode === 'add'
                && (this.librarySelectionLimit === null || this.librarySelectionLimit > 1)
        },
        canReplaceFromLibrary() {
            return this.max !== null && this.max !== undefined
                && Number(this.max) === 1
                && this.images.filter(image => !image.deleted).length === 1
        },
        showLibraryAction() {
            return this.canReplaceFromLibrary || !this.max || this.images.length < this.max
        },
        libraryActionMode() {
            return this.canReplaceFromLibrary ? 'replace' : 'add'
        },
        openLibraryLabel() {
            if (this.libraryActionMode === 'replace') return this.$t('Replace image')
            return this.libraryAllowsMultiple
                ? this.$t('Select images from media library')
                : this.$t('Select image from media library')
        },
        openLibraryHint() {
            if (this.libraryActionMode === 'replace') {
                return this.$t('Replace the current image with one from the media library.')
            }

            return this.libraryAllowsMultiple
                ? this.$t('Select existing images from the media library or upload new ones below.')
                : this.$t('Select an existing image from the media library or upload a new one below.')
        },
        cropperKey() {
            const imageId = _.get(this.imageModal.form, 'image.id')
            const sourceId = _.get(this.imageModal.form, 'image.source.id')
            const src = _.get(this.imageModal.form, 'src', '')

            return [imageId, sourceId, src].filter(Boolean).join(':')
        },
        maxSize() {
            return _.get(this.config, 'maxSize') || 12
        },
        mistralEnabled() {
            return !!process.env.VUE_APP_MISTRAL_ALT_API_KEY
                && process.env.VUE_APP_MISTRAL_ALT_ENABLED !== 'false'
        },
        altAutoEnabled() {
            return _.get(this.setupStore.settingValues, 'altAutoGenerate', true) !== false
        },
        altAutoTriggered() {
            return this.altAutoEnabled && _.get(this.setupStore.settingValues, 'altAutoTrigger', true) !== false
        },
        altMaxGenerations() {
            return parseInt(process.env.VUE_APP_MISTRAL_ALT_MAX_ATTEMPTS || '5', 10)
        },
        uploadData() {
            let uploadData = {
                'context[type]': 'section-image'
            }
            return uploadData
        },
        uploadEndpoint() {
            return `${this.setupStore.uploadEndpoint}/public/${this.activeCms.id}/content`
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
    },
    methods: {
        bumpRenderNonce() {
            this.renderNonce += 1
        },
        getDefaultImageAlt(image, fallbackImage = null) {
            const candidates = [
                _.get(image, 'alt'),
                _.get(fallbackImage, 'alt'),
            ]

            const alt = candidates.find(value => typeof value === 'string' && value.trim())
            return alt ? alt.trim() : ''
        },
        applyDefaultImageAlt(image, fallbackImage = null) {
            if (! image) return image

            if (_.trim(_.get(image, 'alt', ''))) return image

            const alt = this.getDefaultImageAlt(image, fallbackImage)
            if (alt) image.alt = alt

            return image
        },
        getImageSrc(image) {
            // const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')
            // processedFile FIRST: it is the authoritative pointer to the layer the image
            // currently renders (an AI edit, a crop). Reading url/source only meant an
            // applied edit stayed invisible in the CMS editor.
            const sourceUrl = _.get(image, 'processedFile.url')
                || _.get(image, 'url')
                || _.get(image, 'source.url')

            let table = 'images'
            if (image.upload) table = 'uploads'

            // const token = AuthApi.getToken()
            // const src = `${storageRoute}/${table}/${image.id}/${image.name}?token=${token}`
            return sourceUrl || `${storageRoute}/${table}/${image.id}/${image.name}`
        },
        getImageCrop(image) {
            let crop = {}

            const processing = _.get(image, 'settings.processing')
            if (processing) {
                // let { fx, fy, fz, w, h } = parameters

                let fx = _.get(processing, 'x', 0.5)
                let fy = _.get(processing, 'y', 0.5)
                let fz = _.get(processing, 'z', 1)
                let w = _.get(processing, 'w')
                let h = _.get(processing, 'h')

                let cropAspectRatio = this.aspectRatio
                if (! cropAspectRatio && w && h) {
                    w = parseFloat(w)
                    h = parseFloat(h)

                    cropAspectRatio = w / h
                }

                if (! cropAspectRatio) {
                    cropAspectRatio = image.width / image.height
                }

                if (fx && fy && fz && cropAspectRatio) {
                    fx = parseFloat(fx)
                    fy = parseFloat(fy)
                    fz = 1 / parseFloat(fz)

                    const maxWidth = image.width * fz
                    const maxHeight = image.height * fz

                    // if original aspect ratio is larger than the allowed
                    // then the cropped area will be limited by its height
                    if (image.width / image.height > cropAspectRatio) {
                        crop.width = maxHeight * cropAspectRatio
                        crop.height = maxHeight
                    }

                    // if original aspect ratio is smaller than the allowed
                    // then the cropped area will be limited by its width
                    else if (image.width / image.height < cropAspectRatio) {
                        crop.width = maxWidth
                        crop.height = maxWidth / cropAspectRatio
                    }

                    // if original aspect ratio is equal to the allowed
                    // then the cropped area will have the same proportions
                    else {
                        crop.width = maxWidth
                        crop.height = maxHeight
                    }
                }

                crop.x = (image.width * fx) - (crop.width / 2)
                crop.y = (image.height * fy) - (crop.height / 2)
            }

            return crop
        },
        getProcessingObjectFromCropperData(data, originalWidth, originalHeight) {
            // calculate focal point
            const { width, height, x, y } = data

            const originalAspectRatio = originalWidth / originalHeight

            const requestedAspectRatio = width / height

            let fx, fy, fz

            fx =  (x + width / 2) / originalWidth
            fy =  (y + height / 2) / originalHeight

            // if original aspect ratio is larger than the requested
            // then z (zoom) must be calculated by height
            if (originalAspectRatio > requestedAspectRatio) {
                fz = originalHeight / height
            }

            // if original aspect ratio is smaller than the requested
            // then z (zoom) must be calculated by width
            else if (originalAspectRatio < requestedAspectRatio) {
                fz = originalWidth / width
            }

            // if original aspect ratio is equal to the requested
            // then z (zoom) can be calculated by width or height
            else {
                fz = originalWidth / width
            }

            // return `fit=crop&crop=focalpoint&x=${fx}&y=${fy}&z=${fz}&w=${width}&h=${height}`

            return {
                fit: 'crop',
                crop: 'focalpoint',
                x: fx,
                y: fy,
                z: fz,
                w: width,
                h: height,
            }
        },

        deleteImage(id) {

            let images = _.get(this.parent, 'images') || [];
            const i = images.findIndex(image => image.id === id);
            // images.splice(i, 1);
            this.$delete(images, i);

            images = _.get(this.parent, 'images', [])
                .filter(el => el.type === this.config.key)

            sortContents(images)
            localStorage.removeItem(`alt-autogenerated-${id}`)
            localStorage.removeItem(`mistral:alt:${id}`)
        },
        openLibrary(mode = 'add') {
            this.libraryModal.mode = typeof mode === 'string' ? mode : 'add'
            this.libraryModal.visibility = true
        },
        openReplaceLibrary() {
            this.openLibrary('replace')
        },
        getLibraryReplacementTarget() {
            const parentImages = _.get(this.parent, 'images', [])

            if (this.imageModal.form.image) {
                const modalImage = this.imageModal.form.image
                const actualIndex = parentImages.findIndex(image => String(image.id) === String(modalImage.id))

                return {
                    currentImage: actualIndex >= 0 ? parentImages[actualIndex] : modalImage,
                    actualIndex,
                    modalIndex: this.imageModal.form.i || 0,
                    shouldSyncModal: true,
                }
            }

            if (! this.canReplaceFromLibrary) return null

            const currentImage = this.images.find(image => !image.deleted) || this.images[0] || null
            if (! currentImage) return null

            return {
                currentImage,
                actualIndex: parentImages.findIndex(image => String(image.id) === String(currentImage.id)),
                modalIndex: this.images.findIndex(image => String(image.id) === String(currentImage.id)),
                shouldSyncModal: false,
            }
        },
        getImageDuplicateKey(image) {
            const sourceId = _.get(image, 'source.id')
            if (sourceId !== undefined && sourceId !== null && sourceId !== '') {
                return `source:${sourceId}`
            }

            const imageId = _.get(image, 'id')
            if (imageId !== undefined && imageId !== null && imageId !== '') {
                return `image:${imageId}`
            }

            const imageUrl = _.get(image, 'url')
            if (imageUrl) {
                return `url:${imageUrl}`
            }

            return null
        },
        filterDuplicateImages(images, existingImages = []) {
            const seen = new Set(
                existingImages
                    .map(image => this.getImageDuplicateKey(image))
                    .filter(Boolean)
            )

            return images.filter(image => {
                const key = this.getImageDuplicateKey(image)
                if (! key) return true
                if (seen.has(key)) return false

                seen.add(key)
                return true
            })
        },
        selectImageFromLibrary(image) {
            const selectedImages = Array.isArray(image) ? image : [image]
            const replacementTarget = this.getLibraryReplacementTarget()

            if (this.libraryModal.mode === 'replace' && replacementTarget) {
                this.replaceImageFromLibrary(selectedImages[0], replacementTarget)
                this.libraryModal.mode = 'add'
                return
            }

            if (! this.parent.images) this.$set(this.parent, 'images', [])

            const existingImages = (this.parent.images || [])
                .filter(existingImage => existingImage.type === this.config.key)
            const uniqueSelectedImages = this.filterDuplicateImages(selectedImages, existingImages)

            if (! uniqueSelectedImages.length) {
                this.libraryModal.mode = 'add'
                return
            }

            let position = Math.max(...this.images.map(o => _.get(o, 'position', 0) || 0), 0)
            uniqueSelectedImages.forEach(selectedImage => {
                const nextImage = _.cloneDeep(selectedImage)
                position += 1
                nextImage.type = this.config.key
                nextImage.position = position
                this.applyDefaultImageAlt(nextImage)
                this.parent.images.push(nextImage)

                if (this.mistralEnabled && this.altAutoTriggered && !_.trim(nextImage.alt)) {
                    const pushed = this.parent.images[this.parent.images.length - 1]
                    this.$set(pushed, '_altLoading', true)
                    this.altBatchPending += 1
                    this.generateAltTextWithMistral(pushed)
                        .then(alt => { if (alt) { this.$set(pushed, 'alt', alt); this.notifyAltBatchDone(pushed.preferred_name || pushed.name) } else { this.altBatchPending -= 1 } })
                        .catch(() => { this.altBatchPending -= 1 })
                        .finally(() => { this.$delete(pushed, '_altLoading') })
                }
            })

            this.$nextTick(() => {
                sortContents(this.images)
            })

            this.libraryModal.mode = 'add'
        },
        buildImageModalForm(image, i = 0) {
            this.applyDefaultImageAlt(image)

            const orientation = (image.width / image.height) < 3 ? 'portrait' : 'landscape'

            const padding = 40
            const modalWidth = _.min([1200 - padding, window.innerWidth * .9 - padding])
            const modalHeight = window.innerHeight * .8 - padding - 100

            let availibleWidth = modalWidth
            if (orientation === 'portrait') availibleWidth -= modalWidth / 3

            const widthRatio = availibleWidth / image.width
            const heightRatio = modalHeight / image.height

            const ratio = _.min([widthRatio, heightRatio])

            let width = image.width
            let height = image.height

            if (ratio < 1) {
                width *= ratio
                height *= ratio
            }

            if (orientation === 'portrait' && width > 700) {
                const ar = width / height

                width = 700
                height = width / ar
            }

            return {
                orientation,
                dimensions: { width, height },
                crop: this.getImageCrop(image),
                image,
                src: this.getImageSrc(image),
                preview: undefined,
                i,
            }
        },
        applyImageModalForm(form) {
            this.imageModal.loading = true
            this.imageModal.form = form

            this.$nextTick(() => {
                this.imageModal.loading = false

                this.$nextTick(() => {
                    this.refreshCropperPreview()
                })
            })
        },
        refreshCropperPreview() {
            this.$nextTick(() => {
                this.updateCrop()
            })
        },
        getCropperInstance() {
            return _.get(this.$refs, 'cropper.cropper') || null
        },
        handleCropperReady() {
            this.$nextTick(() => {
                this.detectAspectRatioFromCropper()
                this.updateCrop()
            })
        },
        detectAspectRatioFromCropper() {
            let cropData = null
            const dialogCropper = this.getCropperInstance()
            if (dialogCropper) {
                cropData = dialogCropper.getData()
            } else {
                const refs = this.$refs.cropper
                if (Array.isArray(refs) && refs.length) {
                    const first = refs[0]
                    if (first && first.cropper) cropData = first.cropper.getData()
                }
            }
            if (!cropData || !cropData.width || !cropData.height) return
            const ratio = cropData.width / cropData.height
            const match = this.aspectRatioOptions.find(o => {
                if (o.key === 'original' || o.key === 'custom') return false
                const [w, h] = o.key.split(':').map(Number)
                return w && h && Math.abs((w / h) - ratio) < 0.01
            })
            if (match) {
                this._detectingAspectRatio = true
                this.selectedAspectRatioKey = match.key
                this.$nextTick(() => { this._detectingAspectRatio = false })
            }
        },
        buildReplacementImage(image, currentImage) {
            const replacement = _.cloneDeep(image)
            const currentSettings = _.omit(_.get(currentImage, 'settings', {}), ['processing'])

            replacement.type = this.config.key
            replacement.position = _.get(currentImage, 'position', 0)
            replacement.alt = _.get(currentImage, 'alt', '')
            this.applyDefaultImageAlt(replacement, currentImage)

            if (!_.isEmpty(currentSettings)) {
                replacement.settings = currentSettings
            } else {
                delete replacement.settings
            }

            delete replacement.upload
            delete replacement.deleted
            delete replacement.files
            delete replacement.srcset
            // A picked VERSION (crop / AI edit) brings its own pointer + stack — keep those
            // or the replacement silently falls back to the un-edited original. A plain file
            // pick carries none, so this still clears the image being replaced.
            if (!replacement.processing_query_string) {
                delete replacement.processedFile
                delete replacement.processing_query_string
                delete replacement.variants
                delete replacement.activeVariant
            }

            return replacement
        },
        syncReplacementImage(targetImage, image) {
            const replacement = this.buildReplacementImage(image, targetImage)

            Object.keys(targetImage).forEach(key => {
                if (replacement[key] === undefined) {
                    this.$delete(targetImage, key)
                }
            })

            Object.keys(replacement).forEach(key => {
                this.$set(targetImage, key, replacement[key])
            })

            return targetImage
        },
        replaceImageFromLibrary(image, replacementTarget = null) {
            const target = replacementTarget || this.getLibraryReplacementTarget()
            if (! target || ! target.currentImage) return

            const replacement = this.buildReplacementImage(image, target.currentImage)
            const parentImages = [ ...(_.get(this.parent, 'images', []) || []) ]

            if (target.actualIndex >= 0) {
                parentImages.splice(target.actualIndex, 1, replacement)
                this.$set(this.parent, 'images', parentImages)
            }

            if (target.shouldSyncModal) {
                this.applyImageModalForm(this.buildImageModalForm(replacement, target.modalIndex))
            }

            this.bumpRenderNonce()
            this.$forceUpdate()
        },
        openImageModal(id) {
            if (! this.images.length) {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('No images found.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
                return
            }

            // const i = 0
            // const image = this.images[i]
            const i = this.images.findIndex(el => el.id === id)
            if (i < 0) return

            const image = this.images[i]

            // check if image dimensions are too large for the viewport
            // if not, calculate the optimal

            this.imageModal.form = this.buildImageModalForm(image, i)
            this.imageModal.cropMoved = false
            this.selectedAspectRatioKey = 'original'
            this.customAspectRatioInput = ''
            this.altGenerateCount = this.loadAltGenerateCount(image.id)

            const altAutoKey = `alt-autogenerated-${image.id}`
            if (this.mistralEnabled && this.altAutoTriggered && !_.trim(_.get(image, 'alt', '')) && !localStorage.getItem(altAutoKey)) {
                this.altGenerating = true
                localStorage.setItem(altAutoKey, '1')
                this.generateAltTextWithMistral(image)
                    .then(alt => { if (alt) this.$set(this.imageModal.form.image, 'alt', alt) })
                    .catch(() => { localStorage.removeItem(altAutoKey) })
                    .finally(() => { this.altGenerating = false })
            }

            setTimeout(() => {
                this.imageModal.visibility = true
                this.imageModal.loading = true
            }, 300);
        },
        debouncedUpdateCrop: _.debounce(function() { // function scope is needed here
            this.updateCrop()
        }, 50),
        updateCrop() {
            const cropper = this.getCropperInstance()
            if (! cropper) {
                this.imageModal.form.preview = undefined
                return
            }

            this.detectAspectRatioFromCropper()

            try {
                const canvas = cropper.getCroppedCanvas()
                this.imageModal.form.preview = canvas ? canvas.toDataURL() : _.get(this.imageModal.form, 'src')
            } catch (error) {
                this.imageModal.form.preview = _.get(this.imageModal.form, 'src')
            }
        },
        // updateInlineCrop(data, i = 0) {
        //     const image = this.images[i]
        //     if (!image) return
        //
        //     const width = _.get(image, 'width')
        //     const height = _.get(image, 'height')
        //     const processing = this.getProcessingObjectFromCropperData(data.detail, width, height)
        //
        //     this.$set(image, 'settings', { processing })
        // },

        resetImageModal() {
            this.imageModal.form = {
                orientation: undefined,
                dimensions: {},
                crop: {},
                image: undefined,
                src: undefined,
                preview: undefined,
            }
            this.selectedAspectRatioKey = 'original'
            this.customAspectRatioInput = ''
        },
        closeImageModal() {
            this.imageModal.visibility = false
        },
        markCropMoved() {
            this.imageModal.cropMoved = true
        },
        acceptImageModal() {
            const width = _.get(this.imageModal.form, 'image.width')
            const height = _.get(this.imageModal.form, 'image.height')
            const cropper = this.getCropperInstance()
            if (! cropper) return

            const processing = this.getProcessingObjectFromCropperData(cropper.getData(true), width, height)
            this.$set(this.imageModal.form.image, 'settings', { processing })

            // TODO
            const image = this.images[this.imageModal.form.i]
            if (image) this.$set(image, 'settings', { processing })

            this.closeImageModal()
        },
        async uploadChanged(file, fileList) {
            if (fileList.length) this.$set(this.parent, 'locked', true)
            return await this.updateUploadHeaders()
        },
        async updateUploadHeaders() {
            // The computed uploadHeaders reads the store token; make sure it is fresh.
            await ensureFreshToken()
        },
        async validateUpload(file) {
            await this.updateUploadHeaders()
            if (file.size / 1024 / 1024 > this.maxSize) {
                this.$notify.error({
                    title: this.$t('upload.sizeExceeded'),
                    message: this.$t('upload.max', { size: `${this.maxSize}mb` }),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
                // Reject, never `return false`: an async before-upload always returns a promise,
                // and Element aborts only on rejection - a resolved `false` uploads anyway.
                return Promise.reject()
            } else {
                this.$set(this.parent, 'locked', true)
                return true
            }
        },
        async uploadSucceeded(response, file, fileList) {
            let image = _.cloneDeep(response)
            image.type = this.config.key
            image.upload = true

            delete image.hash
            delete image.dimensions
            if ( typeof image.size === 'number' ) image.size = image.size.toString()

            // use dimansions to create a skeleton quicker than onload
            image.width = response.dimensions.width
            image.height = response.dimensions.height

            image.position = Math.max(...this.images.map(o => o.position), 0) + 1
            this.applyDefaultImageAlt(image)

            if (! this.parent.images) this.$set(this.parent, 'images', [])
            this.parent.images.push(image)

            if (this.mistralEnabled && this.altAutoTriggered && !_.trim(image.alt)) {
                this.$set(image, '_altLoading', true)
                this.altBatchPending += 1
                this.generateAltTextWithMistral(image)
                    .then(alt => { if (alt) { this.$set(image, 'alt', alt); this.notifyAltBatchDone(image.preferred_name || image.name) } else { this.altBatchPending -= 1 } })
                    .catch(() => { this.altBatchPending -= 1 })
                    .finally(() => { this.$delete(image, '_altLoading') })
            }

            this.$nextTick(() => {
                let images = this.images
                if (this.$refs.upload !== undefined) {
                    this.$refs.upload.uploadFiles = this.$refs.upload.uploadFiles.filter(el => el.uid !== file.uid)
                    if (! this.$refs.upload.uploadFiles.length) {
                        sortContents(images)
                        this.$delete(this.parent, 'locked', false)
                    }
                } else {
                    sortContents(images)
                    this.$delete(this.parent, 'locked', false)
                }
            })

            return await this.updateUploadHeaders()
        },
        async uploadFailed(err, file) {
            await this.updateUploadHeaders()

            this.$notify.error({
                title: this.$t('upload.notUploaded'),
                message: _.get(file, 'name'),
                iconClass: 'fas el-icon-fa-times',
                position: 'bottom-left',
                customClass: 'dark',
                duration: 8000,
            })
        },

        async getImageAsDataUrl(imageUrl, maxWidth) {
            const response = await axios.get(imageUrl, { responseType: 'blob' })
            return new Promise((resolve, reject) => {
                const objectUrl = URL.createObjectURL(response.data)
                const img = new Image()
                img.onload = () => {
                    URL.revokeObjectURL(objectUrl)
                    const canvas = document.createElement('canvas')
                    let w = img.naturalWidth
                    let h = img.naturalHeight
                    if (maxWidth && w > maxWidth) {
                        h = Math.round(h * maxWidth / w)
                        w = maxWidth
                    }
                    canvas.width = w
                    canvas.height = h
                    canvas.getContext('2d').drawImage(img, 0, 0, w, h)
                    resolve(canvas.toDataURL('image/jpeg', 0.85))
                }
                img.onerror = () => { URL.revokeObjectURL(objectUrl); reject(new Error('load failed')) }
                img.src = objectUrl
            })
        },
        async generateAltTextWithMistral(image, width = parseInt(process.env.VUE_APP_MISTRAL_ALT_WIDTH_IMAGE_INITIAL || '512', 10)) {
            const apiKey = process.env.VUE_APP_MISTRAL_ALT_API_KEY
            if (!apiKey) return ''
            const rawUrl = this.getImageSrc(image)
            let imageData = rawUrl
            try {
                imageData = await this.getImageAsDataUrl(rawUrl, width)
            } catch (e) {
                // fallback to direct URL
            }
            const { data } = await axios.post(
                process.env.VUE_APP_MISTRAL_ALT_API_URL || 'https://api.mistral.ai/v1/chat/completions',
                {
                    model: process.env.VUE_APP_MISTRAL_ALT_MODEL || 'pixtral-12b-2409',
                    messages: [{
                        role: 'user',
                        content: [
                            { type: 'image_url', image_url: imageData },
                            { type: 'text', text: 'Erstelle einen prägnanten, beschreibenden Alt-Text für dieses Bild auf Deutsch. Maximal 125 Zeichen. Nur den Alt-Text, keine weiteren Erklärungen.' }
                        ]
                    }]
                },
                { headers: { Authorization: `Bearer ${apiKey}`, 'Content-Type': 'application/json' } }
            )
            this.altLastTokens = { input: _.get(data, 'usage.prompt_tokens', '?'), output: _.get(data, 'usage.completion_tokens', '?') }
            return _.get(data, 'choices[0].message.content', '').trim()
        },
        loadAltGenerateCount(imageId) {
            if (!imageId) return 0
            return parseInt(localStorage.getItem(`mistral:alt:${imageId}`) || '0', 10)
        },
        notifyAltBatchDone(imageName) {
            this.altBatchCompleted += 1
            this.altBatchPending -= 1
            if (this.altBatchPending === 0) {
                const count = this.altBatchCompleted
                this.altBatchCompleted = 0
                this.$notify({
                    title: this.$t('alt_generated_notify'),
                    message: count === 1
                        ? `<i class="el-icon-fa-magic fas"></i> ${imageName}`
                        : `<i class="el-icon-fa-magic fas"></i> ${count} ${this.$t('alt_generated_batch')}`,
                    dangerouslyUseHTMLString: true,
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 4000,
                })
            }
        },
        saveAltGenerateCount(imageId, count) {
            if (!imageId) return
            localStorage.setItem(`mistral:alt:${imageId}`, String(count))
        },
        async regenerateAlt() {
            if (!this.imageModal.form.image) return
            this.altGenerating = true
            this.altGenerateCount += 1
            const imageId = _.get(this.imageModal.form, 'image.id')
            this.saveAltGenerateCount(imageId, this.altGenerateCount)
            try {
                const retryWidth = this.altGenerateCount <= 1
                    ? parseInt(process.env.VUE_APP_MISTRAL_ALT_WIDTH_IMAGE_RETRY || '512', 10)
                    : parseInt(process.env.VUE_APP_MISTRAL_ALT_WIDTH_IMAGE_RETRY_MAX || '700', 10)
                const alt = await this.generateAltTextWithMistral(this.imageModal.form.image, retryWidth)
                if (alt) this.$set(this.imageModal.form.image, 'alt', alt)
                if (this.altGenerateCount >= this.altMaxGenerations) this.$notify({ title: this.$t('alt_limit_reached_notify'), type: 'warning', position: 'bottom-left', customClass: 'dark', duration: 5000 })
            } catch (e) {
                this.altGenerateCount -= 1
                this.saveAltGenerateCount(imageId, this.altGenerateCount)
                this.$notify.error({ title: this.$t('Alt text could not be generated.'), position: 'bottom-left', customClass: 'dark', duration: 5000 })
            } finally {
                this.altGenerating = false
            }
        },
        calculateMaxWidth() {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxWidth = this.$refs.container.clientWidth
                this.maxWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }
    },
    mounted() {
        this.debouncedCalculateMaxWidth = _.debounce(() => {
            this.calculateMaxWidth()
        }, 100)

        window.addEventListener('resize', this.debouncedCalculateMaxWidth)

        if (typeof window.ResizeObserver === 'function' && this.$refs.container) {
            this.resizeObserver = new window.ResizeObserver(() => {
                this.calculateMaxWidth()
            })
            this.resizeObserver.observe(this.$refs.container)
        }

        this.$nextTick(() => {
            this.calculateMaxWidth()
        })
    },
    destroyed() {
        if (this.debouncedCalculateMaxWidth) {
            window.removeEventListener('resize', this.debouncedCalculateMaxWidth)
            this.debouncedCalculateMaxWidth.cancel()
        }

        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
            this.resizeObserver = null
        }
    }
}
</script>

<style lang="sass" scoped>
#body .el-form-item.flex
    &::v-deep .el-form-item__content
        & > .list,
        & > .list > ul.no-style-list
            display: flex
            flex-wrap: wrap
            gap: 6px

#body .images.flex
    display: flex
    flex-direction: column
    gap: 6px
    &:before
        display: none
    & > .list
        display: block
    & > .list > ul.no-style-list
        display: flex
        flex-wrap: wrap
        gap: 6px
    .dropzone-block
        flex-grow: 1
        width: 100%

    .replace-action
        order: 10
        margin-bottom: 8px
        display: flex
        align-items: center
        justify-content: space-between
        gap: 8px
        .aspect-ratio-group
            display: flex
            align-items: center
            gap: 8px
        &::v-deep .el-dropdown-menu__item.is-selected
            color: $--color-primary
            font-weight: 600
    // &.inline-cropper::v-deep
    //     .cropper-box
    //         padding: 0
    //     .setting .select,
    //     .quill-editor
    //         width: 100%
    //     li.image,
    //     li.content
    //         flex-basis: 100%

.list
    margin-bottom: 10px

.image-actions
    margin-bottom: 10px
    padding: 12px
    border: 1px solid #dce6f8
    border-radius: 8px
    background: #f5f8ff
    &--replace
        display: flex
        justify-content: flex-start
        padding: 0
        border: 0
        border-radius: 0
        background: transparent
    &--inline
        margin-bottom: 10px

.image-library-button
    width: 100%
    min-height: 44px
    font-weight: 600
    &::v-deep span
        white-space: normal
    &--replace
        width: auto
        min-height: 0
        font-weight: 500

.image-actions__hint
    margin-top: 8px
    font-size: 12px
    line-height: 1.45
    color: #6b7280

.image-sort-hint
    flex-basis: 100%
    order: 15
    display: inline-flex
    align-items: center
    gap: 6px
    margin: 2px 0 8px
    font-size: 12px
    line-height: 1.4
    color: #6b7280

.images.is-dragging
    li.content button.el-button
        display: none
    li.dropzone-inline
        // display: none
        pointer-events: none
        opacity: .3

.alt-text-feature
    border: 1px solid #ddd6fe
    border-radius: 10px
    background: linear-gradient(140deg, #faf8ff 0%, #eff0ff 100%)
    padding: 12px 14px
    width: 100%

    &--plain
        background: none
        border: none
        border-radius: 0
        padding: 0
        .alt-text-feature__header
            margin-bottom: 8px
        .alt-text-feature__label
            color: #606266
            font-size: 14px
            font-weight: 400
            i
                display: none
        .alt-text-feature__input::v-deep .el-input__inner
            border-color: #dcdfe6
            &:focus
                border-color: #409eff
                box-shadow: none

    &__header
        display: flex
        align-items: center
        justify-content: space-between
        margin-bottom: 10px

    &__label
        display: flex
        align-items: center
        gap: 6px
        font-size: 12px
        font-weight: 600
        color: #5b4de8
        i
            font-size: 11px
            margin-right: 4px

    &__meta
        display: flex
        align-items: center
        gap: 6px

    &__badge
        font-size: 10px
        font-weight: 700
        letter-spacing: 0.5px
        background: #5b4de8 !important
        border-color: #5b4de8 !important
        color: #fff !important
        border-radius: 4px
        padding: 0 5px

    &__help
        padding: 0
        height: 20px
        width: 20px
        min-height: auto
        min-width: auto !important
        font-size: 11px
        font-weight: 600
        background: #ede9fe
        border-color: #c4b5fd
        color: #5b4de8

    &__input
        &::v-deep .el-input__inner
            border-color: #c4b5fd
            border-radius: 6px
            background: #fff
            &:focus
                border-color: #5b4de8
                box-shadow: 0 0 0 2px rgba(91, 77, 232, 0.1)

    &__footer
        margin-top: 10px
        display: flex
        flex-direction: column
        gap: 6px

    &__btn
        align-self: flex-start
        background: #5b4de8
        border-color: #5b4de8
        color: #fff
        font-weight: 600
        border-radius: 6px
        &:hover, &:focus
            background: #4c3dd3
            border-color: #4c3dd3
            color: #fff

    &__hint
        margin: 0
        font-size: 11px
        color: #9ca3af
        line-height: 1.4

.flex-fields
    display: flex
    .input
        flex-grow: 1
    .comment
        .tooltip
            margin-left: 0.5rem
            padding-top: 23px
            .el-button
                padding: 0
                height: 36px
                width: 36px
                line-height: 20px
                text-align: center
                font-weight: 500
                background: #f9fafc
                &:focus, &:active
                    border-color: #dde0e6
                    color: #606266


.image-dialog
    .content-sidebar
        padding-bottom: 16px

.image-dialog-actions
    display: flex
    justify-content: flex-start
    align-items: center
    margin-bottom: 12px
    gap: 8px
    .aspect-ratio-group
        display: flex
        align-items: center
        gap: 8px
    &::v-deep .el-dropdown-menu__item.is-selected
        color: $--color-primary
        font-weight: 600

.aspect-ratio-control
    display: flex
    align-items: center
    gap: 6px

.aspect-ratio-toolbar
    display: flex
    align-items: center
    justify-content: flex-end
    margin-bottom: 8px
    .aspect-ratio-group
        display: flex
        align-items: center
        gap: 8px
    &::v-deep .el-dropdown-menu__item.is-selected
        color: $--color-primary
        font-weight: 600

.edit-popover
    position: absolute
    inset: 0
    display: flex
    align-items: center
    justify-content: center
    font-size: 1.2rem
    color: #fff
    background-color: rgba(0, 0, 0, 0.3)
    backdrop-filter: grayscale(1)
    border-radius: 4px
    opacity: 0
    transition: opacity .15s ease

.images ul
    margin: 0
    display: flex
    flex-wrap: wrap
    gap: 6px
    & + .plus-box
        margin-top: 10px
    & > li
        // &:only-child
        //     margin-bottom: 0
        a
            display: block
            position: relative
            &::v-deep img
                transition: .15s filter ease, .15s opacity ease
            &.deleted
                cursor: default
                &::v-deep img
                    opacity: .6
                    filter: grayscale(1) blur(1px)
    .image-input
        border-radius: 3px
        border: 1px solid $--border-color-base
        margin-bottom: 0
        display: block
        // height: 150px
        // margin-right: 6px
    & > li > a,
    &::v-deep .thumbnail
        position: relative
        height: 100%
        .el-button.delete-image,
        .el-button.restore-image
            position: absolute
            top: 5px
            right: 5px
            z-index: 2
            // background: rgba(0, 0, 0, 0.2)
            // border: none
            // text-shadow: 0px 0px 5px black
            width: 30px
            height: 30px
            opacity: 0
            transition: opacity .15s ease

            // &:hover
            //     background: rgba(0, 0, 0, 0.6)
        &:hover
            .edit-popover,
            .el-button.delete-image,
            .el-button.restore-image
                opacity: 1

        img
            width: auto
            height: 100%
            display: block
            border-radius: 3px

.image
    display: block
    // height: 80px
    &::v-deep .thumbnail
        position: relative
        height: 100%
        // margin-right: 6px
        img
            width: auto
            height: 100%
            display: block
            border-radius: 3px
            border: 1px solid $--border-color-base
</style>
